import React, { useState, FC, useEffect, useRef, useCallback } from "react"
//import Modal from '@mui/material/Modal';
import { useSelector, useDispatch } from 'react-redux';
import Typography from '@mui/material/Typography';
//import Grid from '@mui/material/Grid';
//import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useLocation, useNavigate } from "react-router-dom";
import { /*getDisclaimerCookie, */setDisclaimerCookie } from '../app/utils'
import { useMediaQuery, useTheme, Dialog, Slide, DialogActions, Link, DialogContent, ListItemText, List, ListItem, Container, Grid, TextField, Divider } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { privacyHref, PrivacyLink, TermsOfUseHref, TermsOfUseLink } from "../app/components/sharedcomponents";
import { showDataDeletionInstructions, showDisclaimer } from "../features/dialogSlice";
import { Box, Stack, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import page2PNG from '../assets/disclaimer_page2.png'
import page3PNG from '../assets/disclaimer_page3.png'
import page4PNG from '../assets/disclaimer_page4.png'
import page5PNG from '../assets/disclaimer_page5.png'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { ReactComponent as WelcomePC1 } from '../assets/welcome_pc_1.svg';
import { ReactComponent as WelcomePC2 } from '../assets/welcome_pc_2.svg';
import { ReactComponent as WelcomePC3 } from '../assets/welcome_pc_3.svg';
import { ReactComponent as WelcomePC4 } from '../assets/welcome_pc_4.svg';
import MobileStepper from '@mui/material/MobileStepper';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import { coonditionContext, Condition, capitalizeWords } from '../index'


import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import PlaceIcon from '@mui/icons-material/Place';
import EmailIcon from '@mui/icons-material/Email';
import emailjs from '@emailjs/browser';
import { useAuthProfile } from "../app/hooks"
import { RandomPatientStory, OnboardingProfilePreview, OnboardingMiniMap, OnboardingResourcePreview, useRandomPatientStory } from './onboarding'

export const Disclaimer: FC = () => {

  const [openDisclaimer, setOpenDisclaimer] = useState(true);
  const disclaimerState = useSelector((state: any) => state.disclaimer)
  const [page, setPage] = useState(1)
  const { story: storyData, isLoading: isStoryLoading } = useRandomPatientStory()
  const dispatch = useDispatch();
  //const loginState = useSelector(state => state.login);
  const navigate = useNavigate();

  async function handleAgreeDisclaimer(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    event.preventDefault()
    dispatch(showDisclaimer(false));
    setDisclaimerCookie()
    setOpenDisclaimer(false)
  }

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  //console.log(isSmallScreen)
  const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="right" ref={ref} {...props} />;
  });
  const { condition } = React.useContext<Condition>(coonditionContext);

  // Touch swipe handling
  const touchStartX = useRef<number | null>(null);
  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  }, []);
  const handleTouchEnd = useCallback((e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    const SWIPE_THRESHOLD = 50;
    if (diff > SWIPE_THRESHOLD && page < 5) {
      setPage(p => p + 1);
    } else if (diff < -SWIPE_THRESHOLD && page > 1) {
      setPage(p => p - 1);
    }
    touchStartX.current = null;
  }, [page]);

  return (
    <Dialog
      open={openDisclaimer}
      sx={{ maxWidth: '90%' }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          py: { xs: 1, sm: 1.5 },
          px: 0,
          left: '5%',
          marginLeft: 'auto',
          marginRight: 'auto',
          backgroundColor: 'rgba(255, 255, 255, 0.82)',
          backdropFilter: 'blur(28px)',
          WebkitBackdropFilter: 'blur(28px)',
          border: 'none',
          boxShadow: '0 8px 32px rgba(80, 60, 160, 0.15), inset 0 0 0 1px rgba(164, 142, 233, 0.18)',
        }
      }}
    >

      <DialogContent
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        sx={{
          pb: 1,
          px: { xs: 2, sm: 3 },
          '&::-webkit-scrollbar': { width: 5 },
          '&::-webkit-scrollbar-track': { background: 'transparent' },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(164, 142, 233, 0.25)',
            borderRadius: 3,
            '&:hover': { background: 'rgba(164, 142, 233, 0.4)' },
          },
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(164, 142, 233, 0.25) transparent',
        }}
      >
        <>
          <Typography textAlign='center' sx={{ mb: 1, fontWeight: 700, fontSize: { xs: 20, sm: 22 }, color: '#1a1a2e' }} id="modal-modal-title" variant="h6">
            Welcome to Patient Connect
          </Typography>
          <Typography id="description1" sx={{ color: '#555', lineHeight: 1.6, textAlign: 'center', fontSize: 14, mb: 2 }}>
            The Polygon Health team sincerely wishes that this platform can be of service to you.
          </Typography>
          <Typography sx={{ color: '#555', lineHeight: 1.6, textAlign: 'center', fontSize: 13, mb: 1 }}>
            To continue, please read and accept our {TermsOfUseLink} and {PrivacyLink}
          </Typography>
          <Button
            disableElevation
            variant="contained"
            onClick={handleAgreeDisclaimer}
            sx={{
              backgroundColor: '#656EFF',
              borderRadius: 2,
              mt: 2,
              mb: 2,
              width: '100%',
              textTransform: 'none',
              fontWeight: 600,
              py: 1.2,
              fontSize: 15,
              boxShadow: '0 2px 8px rgba(101,110,255,0.25)',
              '&:hover': { backgroundColor: '#5A62E8', boxShadow: '0 4px 12px rgba(101,110,255,0.35)' },
            }}
          >
            I Accept
          </Button>
        </>
        {/* <Divider sx={{ mt: 3}}></Divider>
          <Typography textAlign={'center'} sx={{mb: 3,  mt: 3 , color:'#656EFF'}} id="modal-modal-title" variant="h6">
         Patient Connect at a Glance
        </Typography> */}
        {page === 1 &&
          <Stack direction="column" gap={2}>
            {/* <Typography id="modal-modal-title" variant="h6">
              Welcome to Patient Connect
            </Typography> */}
            <Stack gap={2} sx={{ display: 'flex', borderRadius: 3, width: '100%', backgroundColor: 'rgba(244, 240, 255, 0.55)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)', border: 'none', boxShadow: '0 2px 12px rgba(80, 60, 160, 0.06), inset 0 0 0 1px rgba(164, 142, 233, 0.18)', p: 2.5 }}>
              <Typography variant="body1" sx={{ mb: 0.5, color: '#1a1a2e', fontWeight: 700, fontSize: 15 }}>
                How Does Patient Connect Help?
              </Typography>
              <Stack direction="row" spacing={1} sx={{ display: 'flex', alignItems: 'top', }}>
                <Box sx={{ width: '32px', height: '32px' }}>
                  <WelcomePC1 />
                </Box>
                <Stack direction="column" gap={0}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    Connect with patients similar to you
                  </Typography>
                  <Typography variant="body2">
                    Share your story, explore similar experiences, and chat with others.
                  </Typography>
                </Stack>
              </Stack>
              <Stack direction="row" spacing={1} sx={{ display: 'flex', alignItems: 'top' }}>
                <Box sx={{ width: '32px', height: '32px' }}>
                  <WelcomePC2 />
                </Box>
                <Stack direction="column" gap={0}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    Learn from real experiences
                  </Typography>
                  <Typography variant="body2">
                    Discover insights from patients and caregivers.
                  </Typography>
                </Stack>
              </Stack>
              <Stack direction="row" spacing={1} sx={{ display: 'flex', alignItems: 'top' }}>
                <Box sx={{ width: '32px', height: '32px' }}>
                  <WelcomePC3 />
                </Box>
                <Stack direction="column" gap={0}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    Explore resources
                  </Typography>
                  <Typography variant="body2">
                    Use Knowledge Connect to help you search for answers to your questions.
                  </Typography>
                </Stack>
              </Stack>
              {/* <Typography variant="body2" sx={{ fontWeight: 'bold' }}>The Polygon Health team sincerely wishes Patient Connect can be of service to you</Typography> */}
            </Stack>
          </Stack>
        }
        {page === 2 &&
          <Stack direction="column" gap={1.5}>
            <Typography variant="body1" sx={{ color: '#1a1a2e', fontWeight: 700, fontSize: 15 }}>
              Discover Patient Stories
            </Typography>
            <RandomPatientStory story={storyData} isLoading={isStoryLoading} />
            <Typography variant="body2" sx={{ color: '#555', fontSize: 13, lineHeight: 1.5 }}>
              Add your pin, share your story, and connect with others by starting a conversation.
            </Typography>
          </Stack>
        }
        {page === 3 &&
          <Stack direction="column" gap={1.5}>
            <Typography variant="body1" sx={{ color: '#1a1a2e', fontWeight: 700, fontSize: 15 }}>
              Connect with Patients Similar to You
            </Typography>
            <OnboardingProfilePreview story={storyData} />
            <Typography variant="body2" sx={{ color: '#555', fontSize: 13, lineHeight: 1.5 }}>
              Review detailed summaries, see which members have similarities, and start a group chat.
            </Typography>
          </Stack>
        }
        {page === 4 &&
          <Stack direction="column" gap={1.5}>
            <Typography variant="body1" sx={{ color: '#1a1a2e', fontWeight: 700, fontSize: 15 }}>
              Explore Our Map
            </Typography>
            <OnboardingMiniMap story={storyData} />
            <Typography variant="body2" sx={{ color: '#555', fontSize: 13, lineHeight: 1.5 }}>
              Filter the map to find care centers, patient lodging, and other resources for {condition.toLowerCase()}.
            </Typography>
          </Stack>
        }
        {page === 5 &&
          <Stack direction="column" gap={1.5}>
            <Typography variant="body1" sx={{ color: '#1a1a2e', fontWeight: 700, fontSize: 15 }}>
              Explore Resources
            </Typography>
            <OnboardingResourcePreview />
            <Typography variant="body2" sx={{ color: '#555', fontSize: 13, lineHeight: 1.5 }}>
              Find questions to ask, get answers, and discover relevant resources.
            </Typography>
          </Stack>
        }
        {/* {page === 6 &&
          <Stack direction="column" gap={2}>
            <Typography id="modal-modal-title" variant="h6">
              Welcome to Patient Connect
            </Typography>
            <Typography id="description1">
              The Polygon Health team sincerely wishes that this platform can be of service to you.
            </Typography>
            <Typography id="description1">
              To continue, please read and accept our {TermsOfUseLink} and {PrivacyLink}
            </Typography>
          </Stack>

        } */}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pt: 0, pb: 1.5 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box sx={{ width: 32, display: 'flex', justifyContent: 'center' }}>
            {page > 1 && (
              <Button
                disableElevation
                variant="text"
                onClick={() => { setPage(page - 1) }}
                sx={{ minWidth: 32, p: 0.5, color: '#999', '&:hover': { color: '#656EFF', backgroundColor: 'rgba(101, 110, 255, 0.08)' } }}
              >
                <ArrowBackIcon fontSize="small" />
              </Button>
            )}
          </Box>
          <Stack direction="row" alignItems="center" spacing={0.75}>
            {[1, 2, 3, 4, 5].map((dot) => (
              <Box
                key={dot}
                onClick={() => setPage(dot)}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: page === dot ? '#656EFF' : 'rgba(164, 142, 233, 0.25)',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s',
                  '&:hover': { backgroundColor: page === dot ? '#656EFF' : 'rgba(164, 142, 233, 0.5)' },
                }}
              />
            ))}
          </Stack>
          <Box sx={{ width: 32, display: 'flex', justifyContent: 'center' }}>
            {page < 5 && (
              <Button
                disableElevation
                variant="text"
                onClick={() => { setPage(page + 1) }}
                sx={{ minWidth: 32, p: 0.5, color: '#999', '&:hover': { color: '#656EFF', backgroundColor: 'rgba(101, 110, 255, 0.08)' } }}
              >
                <ArrowForwardIcon fontSize="small" />
              </Button>
            )}
          </Box>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}


export const DataDeletionInstructions: FC = () => {
  const [openDisclaimer, setOpenDisclaimer] = useState(true);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  //console.log(isSmallScreen)
  const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="right" ref={ref} {...props} />;
  });
  const dispatch = useDispatch()
  const showDataDeletionInstructionsState: boolean = useSelector((state: any) => {
    return state.dialog.showDataDeletionInstructions
  })
  if (!showDataDeletionInstructionsState) {
    return null
  }
  return (<Dialog
    onClose={() => dispatch(showDataDeletionInstructions(false))}
    sx={{
      width: isSmallScreen ? '100vw' : '50vw', // Set width to 100% on small screens, 90% on larger screens
      maxWidth: isSmallScreen ? 'none' : '1000px', // Remove maximum width on small screens, set to 400px on larger screens
      height: isSmallScreen ? '70vh' : undefined, // Set height to 100% on small screens, 70% on larger screens
      maxHeight: isSmallScreen ? 'none' : '900px', // Remove maximum height on small screens, set to 600px on larger screens
      //position: 'fixed', // Use fixed positioning
      //top: isSmallScreen ? '10vw' : '10vw', // Set bottom to 0 on small screens, 20px on larger screens
      //left: isSmallScreen ? '0' : '70vw', // Set right to 0 on small screens, 20px on larger screens
    }}
    open={showDataDeletionInstructionsState}
    TransitionComponent={Transition}

    PaperProps={{ sx: { width: '100%', height: '100%', borderRadius: '12px', padding: '12px' } }}
  >

    <DialogContent>
      <Typography id="modal-modal-title" variant="h6">
        Data Deletion Instructions
      </Typography>
      <Typography id="description" sx={{ mt: 2 }}>

        To delete your data in the Polygon Health Map application, follow these steps:

        <List sx={{ listStyleType: 'disc', pl: 4, }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Ensure you are logged in to the Polygon Health Map application." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="From the Profile menu, select 'Delete Account'." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Enter 'delete' to confirm the deletion in the Confirm Account Deletion window." />
          </ListItem >
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary='Click on "DELETE ACCOUNT".' />
          </ListItem>
        </List>
      </Typography >

      <Typography id="links" sx={{ mt: 2 }}>
        <div>
          {PrivacyLink}
        </div>
        <div>
          {TermsOfUseLink}
        </div>
      </Typography>
    </DialogContent>


  </Dialog>)
}



export const Contact: FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const message = queryParams.get('message');
  const [value, setValue] = useState(message)
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stateMessage, setStateMessage] = useState<string | null>(null);
  const { authStatus, profile, isLoading: isAuthProfileLoading, isSuccess, isError, error, } = useAuthProfile()
  const sendEmail = (e: any) => {
    e.persist();
    e.preventDefault();
    setIsSubmitting(true);
    emailjs
      .sendForm(
        'service_300ei6f',
        'template_psc8p6a',
        e.target,
        'IREfcB-Wlqf2SmkvK'
      )
      .then(
        (result) => {
          setStateMessage('Message sent!');
          setIsSubmitting(false);
          setTimeout(() => {
            setStateMessage(null);
          }, 5000); // hide message after 5 seconds
        },
        (error) => {
          setStateMessage('Something went wrong, please try again later');
          setIsSubmitting(false);
          setTimeout(() => {
            setStateMessage(null);
          }, 5000); // hide message after 5 seconds
        }
      );

    // Clears the form after sending the email
    e.target.reset();
  };


  const { condition } = React.useContext(coonditionContext);

  return (
    <Container maxWidth="sm">
      <Stack
        sx={{
          pt: { xs: 4, sm: 6, md: 8 },
          pb: { xs: 4, sm: 6, md: 8 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: { xs: 28, sm: 34 } }} component="h1" variant="h3">
          Contact Us
        </Typography>

        {/* Contact Info Card */}
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            borderRadius: 3,
            p: { xs: 2.5, sm: 3 },
            backgroundColor: 'rgba(244, 240, 255, 0.55)',
            backdropFilter: 'blur(24px)',
            WebkitBackdropFilter: 'blur(24px)',
            border: '1px solid rgba(164, 142, 233, 0.18)',
            boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
          }}
        >
          <Stack gap={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: 16 }}>
              Contact Information
            </Typography>
            <Stack direction="row" gap={1.5} alignItems="center">
              <Box sx={{ width: 36, height: 36, borderRadius: '50%', backgroundColor: '#F0EDFF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <EmailIcon sx={{ fontSize: 18, color: '#656EFF' }} />
              </Box>
              <Link href="mailto:contact@polygonhealth.com" underline="hover" sx={{ color: '#656EFF', fontWeight: 500, fontSize: 14 }}>
                contact@polygonhealth.com
              </Link>
            </Stack>
            <Stack direction="row" gap={1.5} alignItems="center">
              <Box sx={{ width: 36, height: 36, borderRadius: '50%', backgroundColor: '#F0EDFF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <PlaceIcon sx={{ fontSize: 18, color: '#656EFF' }} />
              </Box>
              <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.5 }}>
                One Broadway, 14th Floor, Cambridge MA 02142
              </Typography>
            </Stack>
            <Divider sx={{ borderColor: 'rgba(164, 142, 233, 0.12)' }} />
            <Stack direction="row" gap={3}>
              <Link href={privacyHref} underline="hover" target="_blank" sx={{ color: '#656EFF', fontWeight: 500, fontSize: 13 }}>
                Privacy Policy
              </Link>
              <Link href={TermsOfUseHref} underline="hover" target="_blank" sx={{ color: '#656EFF', fontWeight: 500, fontSize: 13 }}>
                Terms of Use
              </Link>
            </Stack>
          </Stack>
        </Paper>

        {/* Feedback Card */}
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            borderRadius: 3,
            p: { xs: 2.5, sm: 3 },
            backgroundColor: 'rgba(244, 240, 255, 0.55)',
            backdropFilter: 'blur(24px)',
            WebkitBackdropFilter: 'blur(24px)',
            border: '1px solid rgba(164, 142, 233, 0.18)',
            boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
          }}
        >
          <Stack gap={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: 16 }}>
              Send us your feedback
            </Typography>
            <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.6 }}>
              We are continuing to improve the {condition} Patient Connect and would love to hear your feedback and suggestions to help us create a better user experience!
            </Typography>
            <form onSubmit={sendEmail}>
              <Stack gap={2}>
                {(authStatus === 'authenticated' && !isAuthProfileLoading && profile)
                  ? <TextField sx={{ display: 'none' }} id="outlined-basic" label="Outlined" variant="outlined" type="text" name="user_email" value={profile.name_public} />
                  : <TextField sx={{ display: 'none' }} id="outlined-basic" label="Outlined" variant="outlined" type="text" name="user_email" value="Anonymous" />
                }
                <TextField
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  name="message"
                  id="outlined-multiline-static"
                  placeholder="Write your feedback here and please include your email if you'd like a response."
                  multiline
                  rows={4}
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: 'rgba(255, 255, 255, 0.6)',
                      '& fieldset': { borderColor: 'rgba(164, 142, 233, 0.2)' },
                      '&:hover fieldset': { borderColor: 'rgba(164, 142, 233, 0.4)' },
                      '&.Mui-focused fieldset': { borderColor: '#656EFF' },
                    },
                  }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  disableElevation
                  disabled={isSubmitting}
                  sx={{
                    backgroundColor: '#656EFF',
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    px: 3,
                    py: 1.2,
                    alignSelf: 'flex-start',
                    boxShadow: '0 2px 8px rgba(101,110,255,0.25)',
                    '&:hover': { backgroundColor: '#5A62E8' },
                  }}
                >
                  Send Feedback
                </Button>
                {stateMessage && (
                  <Typography variant="body2" sx={{ color: stateMessage === 'Message sent!' ? '#4CAF50' : '#E57373', fontWeight: 500 }}>
                    {stateMessage}
                  </Typography>
                )}
              </Stack>
            </form>
          </Stack>
        </Paper>
      </Stack>
    </Container>
  )
}

const IconInCircle = () => {
  return (
    <Box
      sx={{
        width: 29,
        height: 29,
        borderRadius: "50%",
        backgroundColor: "#E1DEF8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .MuiSvgIcon-root": {
          fontSize: 17,
          color: "#62648F",
        },
      }}
    >
      <Diversity3Icon />
    </Box>
  );
};